import { API_ROOT } from '../../config/config'
import { doDelete, doGet, doPost } from './utils'

// const API_ROOT = 'http://localhost:9014/api'

export const getManageBankAccount = (projectCode) => {
  const url = `${API_ROOT}/v1/accounting/bank-account/project/${projectCode}`
  return doGet(url)
}

export const saveManageBankAccount = (request) => {
  const url = `${API_ROOT}/v1/accounting/bank-account`
  return doPost(url, request)
}

export const deleteManageBankAccount = (id) => {
  const url = `${API_ROOT}/v1/accounting/bank-account/${id}`
  return doDelete(url)
}

export const editManageBankAccount = (id) => {
  const url = `${API_ROOT}/v1/accounting/bank-account/${id}`
  return doGet(url)
}
